import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ToolboxAudioClass } from '../../classes/toolbox/toolbox-audio.class';
import { AvProducerService } from '../../services/av-producer/av-producer.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'web-studio-toolbox-audio',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './studio-toolbox-audio.component.html',
  styleUrls: ['./studio-toolbox-audio.component.scss'],
})
export class StudioToolboxAudioComponent extends ToolboxAudioClass implements OnInit, OnDestroy {

  constructor(
          //protected toastService: ToastService,
          protected override avProd: AvProducerService){

      super(avProd);
  }

  ngOnInit(): void {
      this.init();
  }

  ngOnDestroy(): void {
      this.destroy();
  }

}
